module.exports = __webpack_public_path__ + "img/businessman.466ba657.png";